import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { LiveEvent } from '@/types/event'

interface EventCardProps {
  event: LiveEvent
  onClick: () => void
}

function EventCard({ event, onClick }: EventCardProps) {
  const getStatusBadge = () => {
    switch (event.status) {
      case 'live':
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-500 text-white text-xs font-semibold rounded-full">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
            LIVE
          </span>
        )
      case 'scheduled':
        return (
          <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full">
            開催予定
          </span>
        )
      case 'ended':
        return (
          <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-semibold rounded-full">
            終了
          </span>
        )
      default:
        return null
    }
  }

  const formatDate = (dateStr: string) => {
    try {
      return format(new Date(dateStr), 'M月d日 HH:mm', { locale: ja })
    } catch {
      return dateStr
    }
  }

  return (
    <button
      onClick={onClick}
      className="card hover:shadow-lg transition-shadow duration-200 text-left w-full touch-manipulation"
    >
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-lg font-semibold text-gray-900 flex-1 pr-2">
          {event.title}
        </h3>
        {getStatusBadge()}
      </div>

      {event.description && (
        <p className="text-gray-600 text-sm mb-3 line-clamp-2">
          {event.description}
        </p>
      )}

      <div className="space-y-1 text-sm text-gray-500">
        <p>開始: {formatDate(event.start_time)}</p>
        {event.current_participants !== undefined && (
          <p>参加者: {event.current_participants}人</p>
        )}
      </div>

      {event.status === 'live' && (
        <div className="mt-4 pt-4 border-t">
          <span className="text-primary-600 font-semibold">
            今すぐ視聴 →
          </span>
        </div>
      )}
    </button>
  )
}

export default EventCard